import { render, staticRenderFns } from "./TemperatureSetting.vue?vue&type=template&id=50ac1a6c&scoped=true"
import script from "./TemperatureSetting.vue?vue&type=script&lang=js"
export * from "./TemperatureSetting.vue?vue&type=script&lang=js"
import style0 from "./TemperatureSetting.vue?vue&type=style&index=0&id=50ac1a6c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ac1a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50ac1a6c')) {
      api.createRecord('50ac1a6c', component.options)
    } else {
      api.reload('50ac1a6c', component.options)
    }
    module.hot.accept("./TemperatureSetting.vue?vue&type=template&id=50ac1a6c&scoped=true", function () {
      api.rerender('50ac1a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TemperatureSetting.vue"
export default component.exports